import React from "react"
import { Skeleton } from "@mui/material"

import { AppDataTable } from "@components"
import { useHistoryInfo } from "../@hooks"
import { actionsColumn, dorColumn, lorColumn, officeColumn, searchDateColumn, sitesColumn } from "./columns"
import { useSearchParams } from "react-router-dom"
import { isTourDemoActive } from "@signals/app"


export default function HistoryTable() {
	const [searchParams] = useSearchParams()
	const idReportExecution = searchParams.get('idReportExecution')
	const idOfficePickup = searchParams.get('idOfficePickup')
	const idBatch = searchParams.get('idBatch')
	const { data, isLoading } = useHistoryInfo(idReportExecution, idOfficePickup, idBatch)

	if (isTourDemoActive.value && !data?.length && !isLoading) return null

	return <>
		{isLoading && <Skeleton variant="rectangular" height={700}/>}
		{!isLoading && <AppDataTable
			title="Historical List"
			toolbarProps={{ actions: false }}
			data={data}
			columns={[
				searchDateColumn(),
				officeColumn(),
				sitesColumn(),
				dorColumn(),
				lorColumn(),
				actionsColumn(),
			]}
			setHeaderCellProps={() => ({ sx: { fontWeight: "bold" } })}
		/>}
	</>
}